import {
  Heading,
  Spinner,
  Text,
  useInterval,
  VStack,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import useFetchKey from 'hooks/useFetchKey';
import React from 'react';
import { graphql, useSafeRelay } from 'utils/graphClient';
import { PendingFilePlaceholder_node_Query } from './__generated__/PendingFilePlaceholder_node_Query.graphql';

const nodeQuery = graphql`
  query PendingFilePlaceholder_node_Query($id: ID!) {
    node(id: $id) {
      __typename
      id
      ...ItemViewer_node
    }
  }
`;

const POLLING_INTERVAL = 1500;

interface PendingFilePlaceholderProps {
  nodeId: string;
}

export const PendingFilePlaceholder = ({
  nodeId,
}: PendingFilePlaceholderProps) => {
  const [fetchKey, refreshFetchKey] = useFetchKey();
  useInterval(refreshFetchKey, POLLING_INTERVAL);

  const { useLazyLoadQuery } = useSafeRelay();

  useLazyLoadQuery<PendingFilePlaceholder_node_Query>(
    nodeQuery,
    { id: nodeId },
    {
      fetchKey,
      fetchPolicy: 'store-and-network',
    },
  );

  return (
    <VStack maxWidth={800} mt={4}>
      <Spinner size="xl" mb={2} />
      <Heading fontSize="xl">{t`File pending`}</Heading>
      <Text textAlign="center">{t`Please wait until the file is ready.`}</Text>
    </VStack>
  );
};
